export const DAILY_TASKS = [
  {
    name: "Daily Login",
    description: "Log in to the game",
    rewards: {
      currency: 100,
      premiumCurrency: 50
    },
    required: 1,
    progress: 1,
    completed: true,
    done: false
  },
  // {
  //   name: "Battle Champion",
  //   description: "Complete battles",
  //   rewards: {
  //     currency: 200,
  //     premiumCurrency: 25
  //   },
  //   required: 3,
  //   progress: 0,
  //   completed: false,
  //   done: false
  // },
  // {
  //   name: "Coin Collector",
  //   description: "Collect coins from any source",
  //   rewards: {
  //     currency: 150,
  //     premiumCurrency: 0
  //   },
  //   required: 1000,
  //   progress: 0,
  //   completed: false,
  //   done: false
  // },
  // {
  //   name: "Training Master",
  //   description: "Level up any character",
  //   rewards: {
  //     currency: 300,
  //     premiumCurrency: 100
  //   },
  //   required: 1,
  //   progress: 0,
  //   completed: false,
  //   done: false
  // },
  // {
  //   name: "Mission Complete",
  //   description: "Complete missions",
  //   rewards: {
  //     currency: 250,
  //     premiumCurrency: 75
  //   },
  //   required: 2,
  //   progress: 0,
  //   completed: false,
  //   done: false
  // }
];
